import axios from "axios";
import convert from "xml-js";
import { confirm } from "./dialog.js";

const api = axios.create({
  baseURL: `https://verkiezingsdienst.anp.nl/rss/verkiezingen/${
    window.appSettings.endpoint
  }/`,
  headers: {
    "Content-type": "text/xml",
    "Access-Control-Allow-Origin": "*"
  },
  timeout: 25000,
  withCredentials: true
});
api.interceptors.request.use(config => {
  if (!("params" in config)) {
    config.params = {};
  }
  config.params.t = new Date().getTime();
  return config;
});
api.interceptors.response.use(
  xml => {
    const convertedJson = convert.xml2json(xml.data, {
      compact: true,
      spaces: 4
    });
    return JSON.parse(convertedJson);
  },

  error => {
    if (error.response && error.response.status === 401) {
      confirm(
        "Niet ingelogd",
        "U bent niet ingelogd, log in via <a href='https://verkiezingsdienst.anp.nl'>https://verkiezingsdienst.anp.nl</a>",
        null,
        null,
        true
      );
    }
    return Promise.reject(error);
  }
);

export default api;
